import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const updateSurfaceNodeRisk = gql`
  mutation updateSurfaceNodeRisk($input: UpdateSurfaceNodeRiskInput!) {
    updateSurfaceNodeRisk(input: $input) {
      success
      error
    }
  }
`;

export default mutation(updateSurfaceNodeRisk);
